/**
 * Matriz O/A/P — mesma ordem estável que docs/contracts/domain/imoveis/tipo-imoveis-e-matriz-aplicabilidade.md
 * Contrato HTTP: docs/contracts/api/admin/imoveis/get-property-type-applicability-matrix.md
 */
import type { AdminMockRequestHandler } from './mock-api-admin.handlers';

import { of } from 'rxjs';

import { HttpResponse } from '@angular/common/http';

import type { ApplicabilityCode, PropertyTypeMatrixRow } from '@features/admin/property-type-matrix/models/property-type-matrix.models';

function ok<T>(data: T) {
  return { errors: [] as { code: string; messageKey: string }[], data, success: true };
}

/** Legenda domínio O/A/P → código da API. */
const O = 'required' as ApplicabilityCode;
const A = 'optional' as ApplicabilityCode;
const P = 'forbidden' as ApplicabilityCode;

const MATRIX_ROWS: PropertyTypeMatrixRow[] = [
  {
    address: O,
    bathroomCount: O,
    bedroomCount: O,
    description: O,
    parkingSpaceCount: A,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: A,
    typeKey: 'singleStoryHouse',
  },
  {
    address: O,
    bathroomCount: O,
    bedroomCount: O,
    description: O,
    parkingSpaceCount: A,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: A,
    typeKey: 'townhouse',
  },
  {
    address: O,
    bathroomCount: O,
    bedroomCount: O,
    description: O,
    parkingSpaceCount: A,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: A,
    typeKey: 'apartment',
  },
  {
    address: O,
    bathroomCount: O,
    bedroomCount: O,
    description: O,
    parkingSpaceCount: A,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: A,
    typeKey: 'studio',
  },
  {
    address: O,
    bathroomCount: A,
    bedroomCount: A,
    description: O,
    parkingSpaceCount: A,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: O,
    typeKey: 'countryHouse',
  },
  {
    address: O,
    bathroomCount: A,
    bedroomCount: A,
    description: O,
    parkingSpaceCount: A,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: O,
    typeKey: 'farmstead',
  },
  {
    address: O,
    bathroomCount: A,
    bedroomCount: A,
    description: O,
    parkingSpaceCount: A,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: O,
    typeKey: 'farm',
  },
  {
    address: O,
    bathroomCount: P,
    bedroomCount: P,
    description: O,
    parkingSpaceCount: P,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: O,
    typeKey: 'land',
  },
  {
    address: O,
    bathroomCount: P,
    bedroomCount: P,
    description: O,
    parkingSpaceCount: P,
    price: O,
    propertyType: O,
    title: A,
    totalAreaSqm: O,
    typeKey: 'landParcel',
  },
];

export const mockApiPropertyMatrixHandlers: AdminMockRequestHandler[] = [
  {
    method: 'GET',
    path: /^\/api\/admin\/property-type-applicability-matrix$/,
    handle: () =>
      of(
        new HttpResponse({
          body: ok(MATRIX_ROWS),
          status: 200,
        }),
      ),
  },
];
